// jQuery
import './utils/polyfill-nodelist-foreach';
import './utils/jquery';
import $ from 'jquery';
import './polyfills/nodeListForEach';
import $script from 'scriptjs';

import flickityTouchFix from './helpers/FlickityTouchFix';

import 'intersection-observer';
import PxsMap from 'pxs-map';
import PxsVideo from 'pxs-video';
import rimg from 'rimg-shopify';
import ShopifySectionsManager from 'shopify-sections-manager';

// Sections
import Collection from './sections/Collection';
import DynamicSlideshow from './sections/DynamicSlideshow';
import Product from './sections/Product';
import StaticAddresses from './sections/StaticAddresses';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticFooter from './sections/StaticFooter';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from './sections/StaticHeader';
import StaticPassword from './sections/StaticPassword';
import StaticProductRecommendations from './sections/StaticProductRecommendations';

// Components
import ProductList from './components/ProductList';
import Rte from './utils/Rte';
import Select from './components/Select';
import Share from './components/Share';


const scripts = $('[data-scripts]');

$script([scripts.data('shopify-api-url')], () => {
  rimg.init();
  const sections = new ShopifySectionsManager();

  sections.register('dynamic-featured-collection', section => new Collection(section));
  sections.register('dynamic-featured-product', section => new Product(section));
  sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
  sections.register('pxs-map', section => new PxsMap(section));
  sections.register('pxs-video', section => new PxsVideo(section));
  sections.register('static-addresses', section => new StaticAddresses(section));
  sections.register('static-article', section => new Share(section));
  sections.register('static-blog', section => new StaticBlog(section));
  sections.register('static-cart', section => new StaticCart(section));
  sections.register('static-collection', section => new Collection(section));
  sections.register('static-footer', section => new StaticFooter(section));
  sections.register('static-giftcard', section => new StaticGiftCard(section));
  sections.register('static-header', section => new StaticHeader(section));
  sections.register('static-password', section => new StaticPassword(section));
  sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
  sections.register('static-product', section => new Product(section));
  sections.register('static-search-results', section => new ProductList(section));

  $('.rte').each((index, rte) => new Rte({ el: rte }));
  $('select').each((index, select) => new Select({ el: select }));

  flickityTouchFix();
});
